export const actions = {
    ADD_REMOVE_ITEM: 'ADD_REMOVE_ITEM',
    PATCH_BASKET_ITEM: 'PATCH_BASKET_ITEM',
    SET_BASKET_ITEMS: 'SET_BASKET_ITEMS',
    SET_BASKET_UPDATES: 'SET_BASKET_UPDATES',

    PATCH_CART_START: 'PATCH_CART_START',
    PATCH_CART_SUCCESS: 'PATCH_CART_SUCCESS',
    PATCH_CART_FAILED: 'PATCH_CART_FAILED',
    UPDATE_SHIPPING: 'UPDATE_SHIPPING',
    UPDATE_SHIPPING_DONE: 'UPDATE_SHIPPING_DONE',

    SET_PAYMENT_METHOD: 'SET_PAYMENT_METHOD',

    GET_BASKET: 'GET_BASKET',
    GET_BASKET_SUCCESS: 'GET_BASKET_SUCCESS',
    GET_BASKET_FAILED_DONE: 'GET_BASKET_FAILED_DONE',

    SET_REFRESH_BASKET_REQUIRED: 'SET_REFRESH_BASKET_REQUIRED',

    GET_SUGGESTIVE_SELLING: 'GET_SUGGESTIVE_SELLING',
    GET_SUGGESTIVE_SELLING_SUCCESS: 'GET_SUGGESTIVE_SELLING_SUCCESS',
    GET_SUGGESTIVE_SELLING_FAILED: 'GET_SUGGESTIVE_SELLING_FAILED',

    CHECKOUT: 'CHECKOUT',
    CHECKOUT_SUCCESS: 'CHECKOUT_SUCCESS',
    CHECKOUT_FAILED: 'CHECKOUT_FAILED',
    PLACE_ORDER: 'PLACE_ORDER',
    PLACE_ORDER_SUCCESS: 'PLACE_ORDER_SUCCESS',
    PLACE_ORDER_FAILED: 'PLACE_ORDER_FAILED',
    UPDATE_CART_ITEM: 'UPDATE_CART_ITEM',

    CLEAR_BASKET: 'CLEAR_BASKET',
    CLEAR_BASKET_SUCCESS: 'CLEAR_BASKET_SUCCESS',
    CLEAR_BASKET_FAILED: 'CLEAR_BASKET_FAILED',

    APPLY_PROMO_CODE: 'APPLY_PROMO_CODE',
    APPLY_PROMO_CODE_SUCCESS: 'APPLY_PROMO_CODE_SUCCESS',
    APPLY_PROMO_CODE_FAILED: 'APPLY_PROMO_CODE_FAILED',
    REMOVE_PROMO_CODE: 'REMOVE_PROMO_CODE',
    REMOVE_PROMO_CODE_SUCCESS: 'REMOVE_PROMO_CODE_SUCCESS',
    REMOVE_PROMO_CODE_FAILED: 'REMOVE_PROMO_CODE_FAILED',
    SET_DELIVERY_NOTES: 'SET_DELIVERY_NOTES',
    REORDER_ITEMS: 'REORDER_ITEMS',
    CLEAR_FORM_ERRORS: 'CLEAR_FORM_ERRORS',
    CLEAR_PREV_ORDER: 'CLEAR_PREV_ORDER',

    SET_DEFERRED_PATCH_REQUESTS: 'SET_DEFERRED_PATCH_REQUESTS',

    RESET_DELIVERY_NOTES: 'RESET_DELIVERY_NOTES',
    BASKET_GLOBAL_ERROR: 'BASKET_GLOBAL_ERROR',
    REORDER_ITEMS_DONE: 'REORDER_ITEMS_DONE',

    PLACE_ORDER_VIEWED: 'PLACE_ORDER_VIEWED',
    CALL_CANCEL_ORDER: 'CALL_CANCEL_ORDER',
    FEES_EXPANDED: 'FEES_EXPANDED',
    PROMO_CODE_RESULT: 'PROMO_CODE_RESULT',
    TEST_ACTION: 'TEST_ACTION',
    UPDATE_PROFILE_PATCH: ' UPDATE_PROFILE_PATCH',

    APPLY_REFERRAL_CODE: ' APPLY_REFERRAL_CODE',
    APPLY_REFERRAL_CODE_SUCCESS: 'APPLY_REFERRAL_CODE_SUCCESS',
    APPLY_REFERRAL_CODE_FAILED: 'APPLY_REFERRAL_CODE_FAILED',
    TRACKING_SUGGESTIVE_ITEMS: 'TRACKING_SUGGESTIVE_ITEMS',
    
    SET_PRE_ORDER_DATE_TIME_DETAILS: 'SET_PRE_ORDER_CHECKOUT_DETAILS',
    SET_PRE_ORDER_UTENSIL_DETAILS: 'SET_PRE_ORDER_UTENSIL_DETAILS',

    PREORDER_CANCEL:'PREORDER_CANCEL',
    PREORDER_CANCEL_SUCCESS:'PREORDER_CANCEL_SUCCESS',
    PREORDER_CANCEL_FAILED:'PREORDER_CANCEL_FAILED',
}

export const basketGlobalError = (error, canAddItems) => ({
    type: actions.BASKET_GLOBAL_ERROR,
    payload: error,
    canAddItems,
})
export const resetDeliveryNotes = () => ({
    type: actions.RESET_DELIVERY_NOTES,
})

export const updateDeliveryNotes = deliveryNotes => ({
    type: actions.SET_DELIVERY_NOTES,
    payload: deliveryNotes,
})

export const addOrRemoveItem = (
    item,
    operation,
    shouldUpdateCart,
    mixpanelFlagForAi,
    mixpanelFlagForSearch
) => ({
    type: actions.ADD_REMOVE_ITEM,
    payload: {
        item,
        operation,
        shouldUpdateCart,
        mixpanelFlagForAi,
        mixpanelFlagForSearch,
    },
})

export const reorder = order => ({
    type: actions.REORDER_ITEMS,
    payload: order,
})

export const patchBasketItem = (
    items,
    isReorder,
    shouldUpdateCart = false,
    trackingData,
    mixpanelFlagForAi,
    mixpanelFlagForSearch,
    itemsUnavailable
) => ({
    type: actions.PATCH_BASKET_ITEM,
    payload: {
        items,
        isReorder,
        shouldUpdateCart,
        trackingData,
        mixpanelFlagForAi,
        mixpanelFlagForSearch,
        itemsUnavailable,
    },
})

export const setBasketItems = items => ({
    type: actions.SET_BASKET_ITEMS,
    payload: items,
})

export const setBasketUpdates = updates => ({
    type: actions.SET_BASKET_UPDATES,
    payload: updates,
})

export const patchCartStart = () => ({
    type: actions.PATCH_CART_START,
})

export const patchCartSuccess = (
    response,
    trackingData,
    mixpanelFlagForAi,
    mixpanelFlagForSearch
) => ({
    type: actions.PATCH_CART_SUCCESS,
    payload: response,
    trackingData,
    mixpanelFlagForAi,
    mixpanelFlagForSearch,
})

export const patchCartFailed = error => ({
    type: actions.PATCH_CART_FAILED,
    payload: error,
})

export const updateShipping = () => ({
    type: actions.UPDATE_SHIPPING,
})

export const updateProfilePatch = () => ({
    type: actions.UPDATE_PROFILE_PATCH,
})

export const updateShippingDone = () => ({
    type: actions.UPDATE_SHIPPING_DONE,
})

export const setRefreshBasketRequired = flag => ({
    type: actions.SET_REFRESH_BASKET_REQUIRED,
    payload: flag,
})

export const setPaymentMethod = () => ({
    type: actions.SET_PAYMENT_METHOD,
})

export const getBasket = () => ({
    type: actions.GET_BASKET,
})

export const getBasketSuccess = response => ({
    type: actions.GET_BASKET_SUCCESS,
    payload: response,
})

export const getBasketFailedDone = error => ({
    type: actions.GET_BASKET_FAILED_DONE,
    payload: error,
})

export const trackSuggestiveItems = response => ({
    type: actions.TRACKING_SUGGESTIVE_ITEMS,
    payload: response,
})

export const getSuggestiveSelling = () => ({
    type: actions.GET_SUGGESTIVE_SELLING,
})

export const getSuggestiveSellingSuccess = response => ({
    type: actions.GET_SUGGESTIVE_SELLING_SUCCESS,
    payload: response,
})

export const getSuggestiveSellingFailed = error => ({
    type: actions.GET_SUGGESTIVE_SELLING_FAILED,
    payload: error,
})

export const checkout = () => ({
    type: actions.CHECKOUT,
})

export const checkoutSuccess = response => ({
    type: actions.CHECKOUT_SUCCESS,
    payload: response,
})

export const checkoutFailed = error => ({
    type: actions.CHECKOUT_FAILED,
    payload: error,
})

export const placeOrder = payload => ({
    type: actions.PLACE_ORDER,
    payload,
})

export const placeOrderSuccess = response => ({
    type: actions.PLACE_ORDER_SUCCESS,
    payload: response,
})

export const placeOrderFailed = error => ({
    type: actions.PLACE_ORDER_FAILED,
    payload: error,
})

export const updateCartItemProperty = (index, key, value) => ({
    type: actions.UPDATE_CART_ITEM,
    key,
    value,
    index,
})

export const clearBasket = () => ({
    type: actions.CLEAR_BASKET,
})

export const clearBasketSuccess = () => ({
    type: actions.CLEAR_BASKET_SUCCESS,
})

export const clearBasketFailed = () => ({
    type: actions.CLEAR_BASKET_FAILED,
})

export const applyPromoCode = promoCode => ({
    type: actions.APPLY_PROMO_CODE,
    payload: promoCode,
})

export const applyPromoCodeSuccess = response => ({
    type: actions.APPLY_PROMO_CODE_SUCCESS,
    payload: response,
})

export const applyPromoCodeFailed = error => ({
    type: actions.APPLY_PROMO_CODE_FAILED,
    payload: error,
})

export const removePromoCode = () => ({
    type: actions.REMOVE_PROMO_CODE,
})

export const removePromoCodeSuccess = response => ({
    type: actions.REMOVE_PROMO_CODE_SUCCESS,
    payload: response,
})

export const removePromoCodeFailed = error => ({
    type: actions.REMOVE_PROMO_CODE_FAILED,
    payload: error,
})

export const clearFormErrors = () => ({
    type: actions.CLEAR_FORM_ERRORS,
})

export const clearPrevOrder = () => ({
    type: actions.CLEAR_PREV_ORDER,
})

export const setDeferredPatchRequests = ids => ({
    type: actions.SET_DEFERRED_PATCH_REQUESTS,
    payload: ids,
})

export const reorderDone = () => ({
    type: actions.REORDER_ITEMS_DONE,
})

export const placeOrderViewed = () => ({
    type: actions.PLACE_ORDER_VIEWED,
})

export const callCancelOrder = () => ({
    type: actions.CALL_CANCEL_ORDER,
})

export const feesExpanded = () => ({
    type: actions.FEES_EXPANDED,
})

export const promoCodeResult = response => ({
    type: actions.PROMO_CODE_RESULT,
    payload: response,
})

export const testAction = data => ({
    type: actions.TEST_ACTION,
    payload: data,
})

export const applyBasketReferralCode = referralCode => ({
    type: actions.APPLY_REFERRAL_CODE,
    payload: referralCode,
})

export const applyReferralCodeSuccess = response => ({
    type: actions.APPLY_REFERRAL_CODE_SUCCESS,
    payload: response,
})

export const applyReferralCodeFailed = error => ({
    type: actions.APPLY_REFERRAL_CODE_FAILED,
    payload: error,
})

export const setPreOrderDateTimeDetails = payload => ({
    type: actions.SET_PRE_ORDER_DATE_TIME_DETAILS,
    payload,
})

export const setPreOrderUtensilDetails = payload => ({
    type: actions.SET_PRE_ORDER_UTENSIL_DETAILS,
    payload,
})

export const preOrderCancel = (payload) => ({
    type: actions.PREORDER_CANCEL,
    payload
})

export const preOrderCancelSuccess = response => ({
    type: actions.PREORDER_CANCEL_SUCCESS,
    payload: response,
})

export const preOrderCancelFailed = error => ({
    type: actions.PREORDER_CANCEL_FAILED,
    payload: error,
})
